module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-5cb72d0e.png";